import ControlModel from "../../models/controlModel";
import { MODEL_CONTROL_TYPE } from "../../utils/enums";

export function createSortModeControl({ ...args }) {
  return new ControlModel({
    type: MODEL_CONTROL_TYPE.sortMode
  });
}